export default __webpack_public_path__ + "static/media/logo22.3c6b554b.png";